import FileCopyIcon from '@mui/icons-material/FileCopy';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CancelIcon from '@mui/icons-material/Cancel';

const icons = {
  FileCopyIcon,
  CloudDownloadIcon,
  CancelIcon

};

const policyManagement = {
  id: 'policy-management',
  title: 'Policy Management',
  type: 'group',
  children: [
    {
      id: 'policy-issuance',
      title: 'Policy Certificate Issuance',
      type: 'item',
      url: '/policy-certificate-issuance',
      icon: icons.FileCopyIcon
    },
    {
      id: 'policy-download',
      title: 'Policy Certificate Download',
      type: 'item',
      url: '/policy-certificate-download',
      icon: icons.CloudDownloadIcon,
    },
    {
      id: 'policy-cancellation',
      title: 'Policy Certificate Cancellation',
      type: 'item',
      url: '/policy-certificate-cancellation',
      icon: icons.CancelIcon,
    }
  ]
};

export default policyManagement;
